// Agentation developer tooling bootstrap.
//
// Disabled by default. Opt in by setting AGENTATION_ENABLED=true in your
// local environment. The server signals enablement via data-agentation="true"
// on <body>.

let agentationRoot = null;
let mountRequest = 0;

function container() {
  return document.getElementById('agentation-root');
}

function cleanupAgentation() {
  mountRequest += 1;
  agentationRoot?.unmount();
  agentationRoot = null;
  container()?.remove();
}

async function mountAgentation() {
  if (!document.body?.dataset.agentation) {
    cleanupAgentation();
    return;
  }

  const existingContainer = container();

  if (agentationRoot && existingContainer && document.body.contains(existingContainer)) {
    return;
  }

  if (agentationRoot && (!existingContainer || !document.body.contains(existingContainer))) {
    cleanupAgentation();
  }

  const requestId = mountRequest + 1;
  mountRequest = requestId;

  const [{ default: React }, { createRoot }, { Agentation }] = await Promise.all([
    import('react'),
    import('react-dom/client'),
    import('agentation'),
  ]);

  if (requestId !== mountRequest || !document.body?.dataset.agentation) {
    return;
  }

  container()?.remove();

  const mountPoint = document.createElement('div');
  mountPoint.id = 'agentation-root';
  document.body.appendChild(mountPoint);

  agentationRoot = createRoot(mountPoint);
  agentationRoot.render(React.createElement(Agentation));
}

document.addEventListener('turbo:load', mountAgentation);
document.addEventListener('turbo:before-cache', cleanupAgentation);
